// ============================================================
// auth.js
// ------------------------------------------------------------
// เข้าสู่ระบบ + เก็บข้อมูล session
// แยกออกจากหน้า Login เพื่อให้หน้าจอเหลือแต่ส่วนแสดงผล
// ============================================================

import { POST } from "./api.js";
import { setStorageAll } from "./storage.js";
import { mapRoleDetail } from "./permission.js";

// เข้าสู่ระบบ
//   คืน { first_page } เมื่อสำเร็จ (first_page = เมนูแรกที่ผู้ใช้มีสิทธิ์เข้า)
//   คืน null เมื่อไม่สำเร็จ (popup แจ้ง error ถูกเด้งจากชั้น api.js แล้ว)
export const login = async (username, password) => {
  const result = await POST("", "v1/TH/login", { username, password, remember: true });
  if (!result?.status) return null;

  const { token, detail } = result.data;
  const role = mapRoleDetail(detail.role_data.role_detail);
  // เมนูแรกในรายการสิทธิ์ = หน้าที่จะพาไปหลังล็อกอิน
  const first_page = detail.role_data.role_detail[0]?.menu_name || "";

  setStorageAll({
    token: "token " + token,
    username: detail.username,
    full_name: detail.full_name,
    user_id: detail.user_id,
    user_code: detail.user_code,
    user_type: detail.user_type,
    role_detail: role,
    first_page,
  });

  return { first_page };
};
